import { CSSResultGroup, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { html } from 'lit/static-html.js';

import componentStyles from './sic-countdown.css.lit';
import defaultVars from './css-variables/vars-default.css.lit';

@customElement('sic-countdown')
export class SicCountdown extends OutlineElement {
  static styles: CSSResultGroup = [defaultVars, componentStyles];

  @property({ type: String, attribute: 'target-date' })
  targetDate: string | undefined;

  @property({ type: String, attribute: 'extended-date' })
  extendedDate: string | undefined;

  @property({ type: String, attribute: 'text-before' })
  textBefore: string = "Not set";

  @property({ type: String, attribute: 'text-after' })
  textAfter: string = "Not set";

  @property({ type: String, attribute: 'text-extended-before' })
  textExtendedBefore: string = "Not set";

  @property({ type: String, attribute: 'text-extended-after' })
  textExtendedAfter: string = "Not set";

  @state()
  private daysRemaining: number | null = null;

  @state()
  private isExtended: boolean = false;


  @state()
  private humanDate: string | null = null;

  connectedCallback(): void {
    super.connectedCallback();
    this.calculateDaysRemaining();
  }

  calculateDaysRemaining(): void {
    const now = new Date().getTime();

    if (this.targetDate) {
      const parsedTargetDate = new Date(this.targetDate + "T23:59:59Z").getTime();
      const distance = parsedTargetDate - now;

      if (distance >= 0) {
        this.daysRemaining = Math.floor(distance / (1000 * 60 * 60 * 24));
        this.humanDate = this.formatDate(this.targetDate);
        this.isExtended = false;
        return;
      }
    }

    if (this.extendedDate) {
      const parsedExtendedDate = new Date(this.extendedDate + "T23:59:59Z").getTime();
      const distance = parsedExtendedDate - now;

      if (distance >= 0) {
        this.daysRemaining = Math.floor(distance / (1000 * 60 * 60 * 24));
        this.humanDate = this.formatDate(this.extendedDate);
        this.isExtended = true;
        return;
      }
    }

    this.daysRemaining = null;
    this.isExtended = false;
  }


  formatDate(dateStr: string): string {
    const date = new Date(dateStr + "T00:00:01Z"); // Ensure correct parsing
    return date.toLocaleDateString("en-US", { timeZone: "UTC", month: "long", day: "numeric", year: "numeric" });
  }

  render(): TemplateResult {
    return html`
      <div style="display: block;">
        <h3 style="color:#004ea8; font-size: 26px;">
        <slot name-"${this.isExtended ? 'text-extend-before' : 'text-before'}"></slot>
        ${this.humanDate || ""}
          &mdash; only <span class="days-left">${this.daysRemaining ?? 0}
        day${(this.daysRemaining ?? 0) > 1 ? 's' : ''}</span>

        <slot name="${this.isExtended ? 'text-extend-after' : 'text-after'}"></slot>
        </h3>
        <slot name="text-byline" style="font-size: 20px; margin-bottom: var(--spacing-04);"></slot>
        <slot name="cta" style="margin: 1em .75em 1em 0 !important;"></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-countdown': SicCountdown;
  }
}
